import { createContext } from "react";
import type { UseFormReturn } from "react-hook-form";

import type { AdminStructureOpenPitGeometryForm } from "../../schemas";

export type AdminStructureOpenPitGeometryFormContextValue = {
  form: UseFormReturn<AdminStructureOpenPitGeometryForm>;
  canWrite: boolean;
  typePersisted: boolean;
};

export const AdminStructureOpenPitGeometryFormContext =
  createContext<AdminStructureOpenPitGeometryFormContextValue | null>(null);
